import { Navigate, useLocation } from 'react-router-dom';
import useRole from '../../hooks/useRole';

const ProtectedRoute = ({
  children,
  fallbackRedirect = '/login',
  role,
}) => {
  const localUser = localStorage.getItem('user');
  const userRole = useRole(localUser);
  const location = useLocation();

  const hasCorrectRole = role ? userRole === role : true;
  const isAuthenticated = Boolean(localUser);

  // Not authorized — redirect
  if (!isAuthenticated || !hasCorrectRole) {
    return (
      <Navigate
        to={fallbackRedirect}
        state={{ from: location }}
        replace
      />
    );
  }

  // User authenticated & correct role - render children directly
  return <>{children}</>;
};

export default ProtectedRoute;